module.exports = __webpack_public_path__ + "img/start-investing.f596140.png";